import { Form } from "antd";

import { ApplicationConfigurationsDefaultValueEdit } from "src/app/features/ApplicationConfigurations/components/validations/ApplicationConfigurationsDefaultValueEdit";
import { useTranslation } from "src/translations";
import type { FieldMethod, FormFieldFactoryProps } from "../../../Form/types/types";

export const EditableListAppConfigsDefaultValueEditField: FieldMethod = ({ field, rules }: FormFieldFactoryProps) => {
    const { t } = useTranslation();

    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules} label={t(field.translationKeys.label)}>
            <ApplicationConfigurationsDefaultValueEdit key={field.name} />
        </Form.Item>
    );
};
